export default {
	watch: {
		"$route": {
			handler: function () {
				if (typeof this.routeChanged !== "function") {
					return;
				}
				this.routeChanged(this.$route);
			}
		}
	}
};
